import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import { IEmpyreanUser } from '@models/empyrean-user';
import { StoreActions } from '@models/store/store-actions';
import { IStoreState } from '@models/store/store-state';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ObservableStore } from './observable-store/dist';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ObservableStore<IStoreState> {
  private apiUrl: string;

  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    super({ trackStateHistory: false });

    this.appConfig.environment.subscribe(env => {
      this.apiUrl = `${env.API.REFERENCE_DATA}/api/users`;
    });
  }

  public getUsers(): Observable<IEmpyreanUser[]> {
    const state = this.getState();

    if (state && state.users && state.users.length > 0) {
      return of(state.users);
    } else {
      return this.fetchUsers();
    }
  }

  private fetchUsers(): Observable<IEmpyreanUser[]> {
    return this.http.get<IEmpyreanUser[]>(this.apiUrl).pipe(
      map((users: IEmpyreanUser[]) => {
        this.setState({ users }, StoreActions.SetUsers);
        return users;
      }),
      catchError(err => {
        console.warn(err);
        return of([]);
      })
    );
  }

  public async getUserName(userId: number) {
    const users = await this.getUsers().toPromise();
    const user = users.find(u => u.UserId === userId);
    return user ? `${user.FirstName} ${user.LastName}` : '';
  }
}
